var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.41 9.442a.75.75 0 0 1 1.034-.234c.267.168.518.367.746.594a4.292 4.292 0 0 1 .194 5.854l-.193.206-3.886 3.886A4.265 4.265 0 0 1 8.276 21a4.267 4.267 0 0 1-3.03-1.25 4.292 4.292 0 0 1-.192-5.853l.192-.205 1.944-1.945a.75.75 0 0 1 1.148.958l-.087.104-1.943 1.944a2.788 2.788 0 0 0 0 3.936 2.784 2.784 0 0 0 3.749.17l.186-.17L14.13 14.8a2.79 2.79 0 0 0-.486-4.324.75.75 0 0 1-.234-1.035zm1.276-5.19a4.29 4.29 0 0 1 6.059 0 4.293 4.293 0 0 1 .192 5.852l-.192.205-1.944 1.946a.75.75 0 0 1-1.147-.959l.086-.103 1.943-1.944a2.785 2.785 0 0 0 0-3.936 2.789 2.789 0 0 0-3.748-.17l-.187.17L11.86 9.2a2.787 2.787 0 0 0 .486 4.324.75.75 0 1 1-.8 1.268 4.29 4.29 0 0 1-.94-6.447l.194-.206 3.886-3.888z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.9d85e10ace8dfe32125f291243748b67.svg";
export { ForwardRef as ReactComponent };